import { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';

import styles from './AdminSettingsPaperless.module.scss';
import { adminUpdateSettings } from '../actions/adminAction';
import { getAdminFetchSettings } from '../selectors/adminSelectors';

interface IAdminSettingsKnoValidationStoreProps {
  settings: IAdminSetting[];
}

const AdminSettingsKnoValidationWithoutStore = ({ settings }: IAdminSettingsKnoValidationStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isEnableKnoValidation = settings?.find(
    setting => setting.code === AdminSettingCodesEnum.ENABLED_KNO_VALIDATION_SIGNING,
  );

  const [isEnableSetting, setIsEnableSetting] = useState(isEnableKnoValidation?.value === 'true');

  useEffect(() => {
    setIsEnableSetting(isEnableKnoValidation?.value === 'true');
  }, [settings]);

  const onCheckboxChange = useCallback(() => {
    setIsEnableSetting(!isEnableSetting);
  }, [isEnableSetting]);

  const onSave = useCallback(() => {
    if (!isEnableKnoValidation) return;

    dispatch(
      adminUpdateSettings(
        {
          ...isEnableKnoValidation,
          value: isEnableSetting ? 'true' : 'false',
        },
        isEnableKnoValidation.id,
      ),
    );
  }, [isEnableSetting]);

  return (
    <div className={styles.Wrapper}>
      <div className="shared-section-title">Настройки проверки КНО</div>
      <Checkbox
        id={'isEnableSettingCheckbox'}
        theme="system"
        onChange={onCheckboxChange}
        checked={isEnableSetting}
        label={'Проверять организации в поле «Контрольный (надзорный) орган» паспортов и ЭЦП'}
        className={styles.CheckBox}
      />
      <Button color="primary" variant="contained" text="Сохранить изменения" onClick={onSave} />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IAdminSettingsKnoValidationStoreProps => ({
  settings: getAdminFetchSettings(state),
});

export const AdminSettingsKnoValidation = connect(mapStateToProps)(AdminSettingsKnoValidationWithoutStore);
